import { Animated, Col } from "@commonlibs";
import { useControlled, usePreventBodyScroll } from "@commonlibs";
import clsx from "clsx";
import { MainDrawerRoot, MainDrawerWrapper } from "./MainDrawer.styles";
import { MainDrawerProps } from "./MainDrawer.types";
import MainDrawerBody from "./MainDrawerBody/MainDrawerBody";
import MainDrawerHeader from "./MainDrawerHeader/MainDrawerHeader";
import { useEffect, useState } from "react";

const DEFAULT_DRAWER_ANIMATION_DURATION = 400;

const MainDrawer = ({
    className,
    defaultOpen = false,
    open: openProp,
    onClose,
    transitionsDuration = { enter: DEFAULT_DRAWER_ANIMATION_DURATION, exit: DEFAULT_DRAWER_ANIMATION_DURATION },
    ...rest
}: MainDrawerProps) => {
    //hooks
    const [open, setOpen] = useControlled(defaultOpen, openProp, onClose);
    const [absolute, setAbsolute] = useState(false);

    /*
     * This effect is because in large screens if the position is absolute
     * the MainDrawerRoot will be absolutely positioned and the app won't be clickable
     */
    useEffect(() => {
        if (open) setAbsolute(true);
        else {
            setTimeout(() => {
                setAbsolute(false);
            }, DEFAULT_DRAWER_ANIMATION_DURATION);
        }
    }, [open]);

    usePreventBodyScroll(open);

    //handlers
    function handleCloseDrawer() {
        setOpen(false);
    }

    return (
        <MainDrawerRoot open={absolute}>
            <Animated.Slide direction="right" in={open} duration={transitionsDuration}>
                <MainDrawerWrapper className={clsx("main-drawer", className)} justifyContent="space-between" {...rest}>
                    <MainDrawerHeader onMenuClick={handleCloseDrawer} />
                    <Col flex={1}>
                        <MainDrawerBody closeDrawer={handleCloseDrawer} />
                    </Col>
                </MainDrawerWrapper>
            </Animated.Slide>
        </MainDrawerRoot>
    );
};

export default MainDrawer;
